(function () {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('activite-assistant', {
                parent: 'entity',
                url: '/suivi-assistant',
                title: "Suivi Assistant",
                sidebarMeta: {
                    icon: 'glyphicon glyphicon-tower',
                    order: 8
                },
                data: {
                    authorities: ['ROLE_RESPONSABLE_ETABLISSEMENT', 'ROLE_ADMIN', 'ROLE_RESPONSABLE', 'ROLE_ASSISTANT', 'ROLE_RESPONSABLE_ASSISTANT', 'ROLE_RESPONSABLE_INSCRIPTION'],
                    pageTitle: 'josdaviApp.activiteAssistant.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/activite-assistant/activite-assistants.html',
                        controller: 'ActiviteAssistantController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('activiteAssistant');
                        $translatePartialLoader.addPart('moyenCommunication');
                        $translatePartialLoader.addPart('typeActivite');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();
